import { getSystemIcon } from '../../services/organization';
import { SystemLink } from './SystemLink';

export function SystemIcon({
  system,
  value,
  fallback,
  color = 'gray',
}: {
  system?: string;
  value?: string;
  fallback: React.ExoticComponent;
  color?: string;
}) {
  const Icn = getSystemIcon(system ?? '', fallback);
  const interactive = Boolean(system && value && (system === 'email' || system === 'url' || system === 'phone'));
  return (
    <SystemLink system={system} value={value}>
      <Icn size={16} color={color} cursor={interactive ? 'pointer' : 'default'} />
    </SystemLink>
  );
}
